import { use } from 'react'

import { SessionContext, type Session } from './SessionContext'

export function useSession(): Session {
  const session = use(SessionContext)
  if (!session) throw new Error('useSession must be used inside a SessionProvider')
  return session
}
